import { render, staticRenderFns } from "./products-list.vue?vue&type=template&id=a03068e4&scoped=true"
import script from "./products-list.vue?vue&type=script&lang=js"
export * from "./products-list.vue?vue&type=script&lang=js"
import style0 from "./products-list.vue?vue&type=style&index=0&id=a03068e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a03068e4",
  null
  
)

export default component.exports